@if(user){
<div class="container-fluid h-100">
  <div class="row h-100">
    <div class="col-md-3 bg-light p-3 d-flex flex-column">
      <div class="d-none d-md-block text-center mb-3">
        <p class="fw-bold">{{ "switch_calendar_view" | transloco }}:</p>
        <div class="d-flex align-items-center justify-content-center gap-2">
          <div class="form-check">
            <input
              class="form-check-input"
              type="radio"
              id="gridView"
              name="viewMode"
              [value]="true"
              [(ngModel)]="isGridView"
            />
            <label
              class="form-check-label d-flex align-items-center"
              for="gridView"
            >
              <i class="bi bi-grid-3x3 me-1"></i>
              {{ "grid" | transloco }}
            </label>
          </div>

          <div class="form-check">
            <input
              class="form-check-input"
              type="radio"
              id="listView"
              name="viewMode"
              [value]="false"
              [(ngModel)]="isGridView"
            />
            <label
              class="form-check-label d-flex align-items-center"
              for="listView"
            >
              <i class="bi bi-list me-1"></i>
              {{ "list" | transloco }}
            </label>
          </div>
        </div>
      </div>

      <div class="d-flex justify-content-between align-items-center">
        <h5>{{ "filters" | transloco }}</h5>
        <button
          class="btn btn-outline-primary btn-sm"
          (click)="resetAllFilters()"
        >
          {{ "reset" | transloco }}
        </button>
      </div>

      <div [formGroup]="myForm" class="mt-3">
        <div class="d-flex justify-content-between align-items-center">
          <h6>{{ "type" | transloco }}</h6>
          <button class="btn btn-sm" (click)="resetTypesFilter()">
            <i class="bi bi-x-lg"></i>
          </button>
        </div>

        <div class="form-check">
          <input
            class="form-check-input"
            type="checkbox"
            id="services"
            formControlName="services"
          />
          <label class="form-check-label" for="services">
            {{ "services" | transloco }}
          </label>
        </div>
        <div class="form-check">
          <input
            class="form-check-input"
            type="checkbox"
            id="education_program"
            formControlName="education_program"
          />
          <label class="form-check-label" for="education_program">
            {{ "education_programs" | transloco }}
          </label>
        </div>
        <div class="form-check">
          <input
            class="form-check-input"
            type="checkbox"
            id="rehabilitation_program"
            formControlName="rehabilitation_program"
          />
          <label class="form-check-label" for="rehabilitation_program">
            {{ "rehabilitation_programs" | transloco }}
          </label>
        </div>
      </div>
    </div>

    <div class="col-md-9 bg-white p-3">
      @if (isGridView) {
      <app-calendar-grid-view
        [initDate]="initGridDate"
        [type]="selectedTypes"
        [patientId]="user.id"
      ></app-calendar-grid-view>
      } @else {
      <app-calendar-list-view
        (navLinkClick)="listNavLinkClick($event)"
        [type]="selectedTypes"
        [patientId]="user.id"
      ></app-calendar-list-view>
      }
    </div>
  </div>
</div>
}
